import { render } from "./AddPaymentMethod.vue?vue&type=template&id=cf3c887a&scoped=true"
import script from "./AddPaymentMethod.vue?vue&type=script&lang=js"
export * from "./AddPaymentMethod.vue?vue&type=script&lang=js"

import "./AddPaymentMethod.vue?vue&type=style&index=0&id=cf3c887a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf3c887a"]])

export default __exports__